/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { useEffect, useContext, useState } from 'react';

/**
 * Root Imports
*/

import { PageContext } from '~/components/PageProvider';
import { Box } from '~/components/Widget/Box';

/**
 * Local Imports
*/



/**
 * Locals
*/



/**
 * Exports
*/

export function Dashboard(props) {
  /** Contexts **/
  
  const page = useContext(PageContext);
  
  /** States **/
  
  
  /** Side-Effects **/
  
  useEffect(() => {
    handleMount();
  }, []);
  
  /** Event Handlers **/
  
  /**
   * 
   */
  const handleMount = () => {
    page.change({
      group: 'dashboard',
      breadcrumbs: 'Dashboard'
    });
  };
  
  /** Renderers **/
  
  
  /** Output **/
  
  return (
    <Box>
      <h1>Welcome!</h1>
    </Box>
  );
}